import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';
import Analytics from '@ublend-npm/aula-analytics';
import { Link, DisabledLink } from './ExternalLink.styled';
import { looks } from './ExternalLink.variant';
import Lti1p3Launch from '../Lti1p3Launch/Lti1p3Launch';
import { CLICK_ASSIGNMENT_EXTERNAL_LINK } from '$variables/analyticsEvents';
import * as TYPES from '$variables/types';
import { providers } from '$variables/constants';

const ExternalLink = React.forwardRef(
  (
    {
      'data-testid': dataTestId,
      disabledText,
      look,
      onClick,
      to,
      assignment,
      mobileActionsAndEvents,
    },
    ref
  ) => {
    const isLti1p3 = assignment?.provider === providers.LTI_1P3;
    const [isLaunching, setIsLaunching] = useState(false);
    const { mobOnClickEvent } = mobileActionsAndEvents;

    const handleClick = (event) => {
      event.stopPropagation();

      if (onClick && !isLti1p3) {
        event.preventDefault();
        onClick();
      }

      if (isLti1p3 || (onClick && isLti1p3)) {
        event.preventDefault();
        setIsLaunching(true);
      }

      if (mobOnClickEvent) {
        mobOnClickEvent(null);
      }

      Analytics.track({
        event: CLICK_ASSIGNMENT_EXTERNAL_LINK,
        externalLink: isLti1p3 ? providers.LTI_1P3 : to || 'turnitin',
      });
    };

    if (disabledText) {
      return (
        <Tooltip title={disabledText} position="top" spacing={4}>
          <DisabledLink aria-label="Disabled link" data-testid={dataTestId}>
            View
          </DisabledLink>
        </Tooltip>
      );
    }

    return (
      <Link
        aria-label="Open link in a new tab"
        data-testid={dataTestId}
        href={to}
        look={looks[look]}
        onClick={handleClick}
        target="_blank"
        ref={ref}
        disabled={isLaunching}
      >
        {isLaunching ? (
          <Lti1p3Launch
            providerId={assignment.providerId}
            resourceLinkId={assignment.resourceLinkId}
            resourceLinkTitle={assignment.title}
            assignmentId={assignment.id || assignment.objectId}
            onSuccessLaunch={() => setIsLaunching(false)}
            onErrorLaunch={() => setIsLaunching(false)}
          />
        ) : null}
        View
      </Link>
    );
  }
);

ExternalLink.propTypes = {
  to: PropTypes.string,
  look: PropTypes.string,
  onClick: PropTypes.func,
  disabledText: PropTypes.string,
  'data-testid': PropTypes.string,
  assignment: PropTypes.shape(TYPES.Assignment).isRequired,
  mobileActionsAndEvents: PropTypes.shape(TYPES.MobileActionsAndEvents),
};

ExternalLink.defaultProps = {
  look: 'default',
  to: '',
  onClick: undefined,
  disabledText: null,
  'data-testid': undefined,
  mobileActionsAndEvents: {},
};

export default ExternalLink;
